<template>
<div class="step step--type-3">
<div class="step__main">
<h2 class="heading-step">
<span class="heading-step__step">STEP<em>3</em> </span>
<span class="heading-step__title">その他情報の入力</span>
<!-- /.heading-step --></h2>

<div class="box-alert" v-show="value13_error">
<ul class="list-alert">
<li class="list-alert__item" v-show="value13_error"><strong>「現在から退職までの平均見込年収<sup>*</sup>（賞与含む）」が未入力です。</strong></li>
<!-- /.list-alert --></ul>
<!-- /.box-alert --></div>

<div class="column column--col-2">
<div class="column__inner">
<div class="column__col" v-show="value3 === '会社員・公務員'">
<h3 class="heading-label"><label for="label-dummy-income-price-01">現在から退職までの平均見込年収<sup>*</sup>（賞与含む）</label></h3>

<div class="form-text">
<input type="text" name="name-dummy-income-price-01" id="label-dummy-income-price-01" :class="['form-text__input', { 'is-error': value13_error }]" placeholder="金額を入力" v-model="value13" @change="changeValue13ByEvent" @blur="changeValue13ByEvent"><span class="form-text__unit">万円</span>
<!-- /.form-text --></div>
<!-- /.column__col --></div>

<div class="column__col" v-show="value3 === '会社員・公務員'">
<h3 class="heading-label"><label for="label-dummy-retirement-03">退職予定年齢</label></h3>

<div class="form-select">
<select name="name-dummy-retirement-03" id="label-dummy-retirement-03" class="form-select__select" v-model="value14" @change="changeValue14ByEvent">
<option value="">選択ください</option>
<option v-for="(num, index) in (70 - value1)" :value="value1 + num" :key="index">{{(value1 + num)}}歳</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>
<!-- /.column__col --></div>

<!-- ▼▼▼ 「職業区分」が「自営業」もしくは「専業主婦・専業主夫」の場合表示 ▼▼▼ -->
<div class="column__col" v-show="value3 === '自営業' || value3 === '専業主婦・専業主夫'">
<h3 class="heading-label"><label for="label-dummy-household-agency-01">世帯の所得<sup>*</sup></label></h3>

<div class="form-select">
<select name="name-dummy-household-agency-01" id="label-dummy-household-agency-01" class="form-select__select" v-model="value15" @change="changeValue15ByEvent">
<option value="">選択ください</option>
<option value="210万円以下">210万円以下</option>
<option value="210万円超～600万円以下">210万円超～600万円以下</option>
<option value="600万円超">600万円超</option>
<!-- /.form-select__select --></select>
<!-- /.form-select --></div>

<!-- /.column__col --></div>
<!-- ▲▲▲ 「職業区分」が「自営業」もしくは「専業主婦・専業主夫」の場合表示 ▲▲▲ -->
<!-- /.column__inner --></div>
<!-- /.column --></div>

<ul class="list-notice" v-show="value3 === '会社員・公務員'">
<li class="list-notice__item"><small><span class="list-notice__item-mark">＊ </span>年収の上限は以下の算式に基づき1,194万円とし、これに12分の1を乗じたものを平均標準報酬額とみなして算出しています。<br>標準報酬月額の最大62万円×12か月＋標準賞与額の最大150万円×3回＝1,194万円<br>同一の年収であっても標準報酬月額・標準賞与額の額により試算結果は異なるため、上記年収を超える場合で賞与の割合が少ない方は年収の8割程度の金額を入力されることをお勧めします。</small></li>
<!-- /.list-notice --></ul>

<ul class="list-notice" v-show="value3 === '自営業' || value3 === '専業主婦・専業主夫'">
<li class="list-notice__item"><small><span class="list-notice__item-mark">＊ </span>総所得金額等から住民税の基礎控除額33万円を差し引いた額。</small></li>
<!-- /.list-notice --></ul>
<!-- /.step__main --></div>

<div class="step__foot">
<div class="step__foot-button">
<div class="button-submit">
<router-link tag="button" type="button" class="button-submit__button" to="step4" v-if="validateStep3">
<span class="button-submit__button-inner">試算する</span>
<!-- /.button-submit__button --></router-link>
<router-link tag="button" type="button" class="button-submit__button" to="step4" v-else disabled>
<span class="button-submit__button-inner">試算する</span>
<!-- /.button-submit__button --></router-link>
<!-- /.button-submit --></div>

<div class="button-back">
<router-link tag="button" type="button" class="button-back__button" to="step2agency" v-if="agencyMode">
<span class="button-back__button-inner">STEP2に戻る</span>
<!-- /.button-back__button --></router-link>
<router-link tag="button" type="button" class="button-back__button" to="step2" v-else>
<span class="button-back__button-inner">STEP2に戻る</span>
<!-- /.button-back__button --></router-link>
<!-- /.button-back --></div>
<!-- /.step__foot-button --></div>
<!-- /.step__foot --></div>
<!-- /.step --></div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Utils from '../assets/js/Utils';

    export default {
        computed: {
            ...mapGetters([
                'agencyCode',
                'agentCode',
                'agencyMode',
                'value1',
                'value3',
                'value13_text',
                'value14_text',
                'value15_text',
                'validateStep2',
                'validateStep2Agency',
                'validateStep3'
            ]),
            value13: {
                get() {
                    let value = this.$store.getters.value13;

                    // 内部で乗算されているのを元に戻す
                    if (typeof value === 'number' && isFinite(value)) {
                        value /= 10000;
                        value = Utils.addComma(value);
                    }

                    return value;
                },
                set(value) {
                    this.changeValue13(value);
                }
            },
            value14: {
                get() {
                    return this.$store.getters.value14;
                },
                set(value) {
                    this.changeValue14(value);
                }
            },
            value15: {
                get() {
                    return this.$store.getters.value15;
                },
                set(value) {
                    this.changeValue15(value);
                }
            }
        },
        data() {
            return {
                value13_error: false
            };
        },
        methods: {
            ...mapActions([
                'changeValue13',
                'changeValue13Text',
                'changeValue14',
                'changeValue14Text',
                'changeValue15',
                'changeValue15Text'
            ]),
            changeValue13ByEvent(event) {
                const currentTarget = event.currentTarget;
                const value = currentTarget.value;
                const numberChecked = Utils.isNumberString(value);
                let number = '';
                let numberStringWithComma = '';

                this.value13_error = !numberChecked;
                this.changeValue13(value);

                number = this.$store.getters.value13;

                // 内部で乗算されているのを元に戻す
                if (typeof number === 'number' && isFinite(number)) {
                    number /= 10000;
                    numberStringWithComma = Utils.addComma(number);
                }

                currentTarget.value = numberStringWithComma;
                this.changeValue13Text(numberStringWithComma);
            },
            changeValue14ByEvent(event) {
                const currentTarget = event.currentTarget;
                const textContent = Utils.extractOptionElementTextContentBySelectElement(currentTarget);

                this.changeValue14Text(textContent);
            },
            changeValue15ByEvent(event) {
                const currentTarget = event.currentTarget;
                const textContent = Utils.extractOptionElementTextContentBySelectElement(currentTarget);

                this.changeValue15Text(textContent);
            }
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                const s = window.s;

                if (s) {
                    if (from.name !== null && to.name === 'Step3') {
                        // 他 STEP からの遷移時
                        let agencyVariableString;
                        let sCode;

                        if (vm.agencyMode) {
                            agencyVariableString = vm.agencyCode + '|' + vm.agentCode;
                        } else {
                            agencyVariableString = '|';
                        }

                        s.pageName = '【RWD】公的保障試算ツール(STEP3)';
                        s.prop11 = agencyVariableString;
                        s.eVar11 = agencyVariableString;
                        s.prop12 = '';
                        s.eVar12 = '';
                        s.prop13 = '';
                        s.eVar13 = '';
                        s.prop14 = '';
                        s.eVar14 = '';
                        s.prop15 = '';
                        s.eVar15 = '';
                        s.events = '';
                        s.linkTrackEvents = '';

                        sCode = s.t();

                        if (sCode) {
                            document.write(sCode);
                        }
                    }
                }
            });
        },
        beforeRouteLeave(to, from, next) {
            const sendTrackingCode = () => {
                const s = window.s;

                if (s) {
                    if (from.name === 'Step3' && to.name === 'Step4') {
                        const values = [
                            this.value15_text,
                            this.value13_text,
                            this.value14_text
                        ];
                        const joinedValues = values.join('|');

                        s.prop14 = joinedValues;
                        s.eVar14 = joinedValues;
                        s.linkTrackVars = 'prop14,eVar14';
                        s.tl(window, 'o', '公的保障試算ツール 試算する');
                    } else if (from.name === 'Step3' && (to.name === 'Step2' || to.name === 'Step2Agency')) {
                        const values = [
                            this.value15_text,
                            this.value13_text,
                            this.value14_text
                        ];
                        const joinedValues = values.join('|');

                        s.prop14 = joinedValues;
                        s.eVar14 = joinedValues;
                        s.linkTrackVars = 'prop14,eVar14';
                        s.tl(window, 'o', '公的保障試算ツール STEP2に戻る');
                    }
                }
            };

            if (from.name === 'Step3' && to.name === 'Step4') {
                if (this.validateStep3) {
                    sendTrackingCode();
                    next();
                } else {
                    next(false);
                }
            } else if (!this.agencyMode && from.name === 'Step3' && to.name === 'Step2') {
                sendTrackingCode();
                next();
            } else if (this.agencyMode && from.name === 'Step3' && to.name === 'Step2Agency') {
                sendTrackingCode();
                next();
            } else {
                next(false);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Step3.vue